/**
 * KPI — presentational only. Accepts pre-formatted string values.
 */
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export default function KPI({ label, value, delta, deltaLabel, tone = "neutral", testid, unit }) {
  const toneColor = {
    success: "text-emerald-400",
    danger: "text-red-400",
    amber: "text-amber-400",
    neutral: "text-zinc-100",
  }[tone];
  const deltaColor =
    delta > 0 ? "text-emerald-400" : delta < 0 ? "text-red-400" : "text-zinc-500";
  const DeltaIcon = delta > 0 ? ArrowUpRight : ArrowDownRight;

  return (
    <div
      data-testid={testid}
      className="relative bg-[#0f1524] border border-[#17223a] p-5 hover:border-[#1c2a4a] transition-colors"
    >
      <div className="flex items-start justify-between mb-6">
        <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 font-mono">
          {label}
        </div>
        {delta !== undefined && delta !== null && (
          <div className={`flex items-center gap-1 text-[10px] font-mono ${deltaColor}`}>
            <DeltaIcon size={11} />
            <span>{Math.abs(delta)}%</span>
          </div>
        )}
      </div>
      <div className="flex items-baseline gap-1.5">
        <div className={`font-display font-black text-2xl sm:text-3xl lg:text-4xl tracking-tight tabular-nums ${toneColor}`}>
          {value}
        </div>
        {unit && <div className="text-xs text-zinc-500 font-mono">{unit}</div>}
      </div>
      {deltaLabel && (
        <div className="text-[10px] text-zinc-500 mt-3 uppercase tracking-[0.15em] font-mono">
          {deltaLabel}
        </div>
      )}
    </div>
  );
}
